export const toPhone = v => {
  if (!v) return v

  let onlyNums = v.replace(/[^\d]/g, '')

  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`
}
